import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingContainer", "inputContainer", "secretInput", "toggleButton", "eyeIcon"]

  changeSecret(event) {
    event.preventDefault()

    // Hide the existing container and show the input
    if (this.hasExistingContainerTarget) {
      this.existingContainerTarget.style.display = 'none'
    }

    // Show the input container and enable the input so it gets submitted
    this.inputContainerTarget.style.display = 'block'

    if (this.hasSecretInputTarget) {
      this.secretInputTarget.disabled = false
      this.secretInputTarget.focus()
    }
  }

  cancel(event) {
    event.preventDefault()

    // Hide the input container and show the existing container
    this.inputContainerTarget.style.display = 'none'

    if (this.hasExistingContainerTarget) {
      this.existingContainerTarget.style.display = 'block'
    }

    // Disable the input and clear any typed value
    if (this.hasSecretInputTarget) {
      this.secretInputTarget.disabled = true
      this.secretInputTarget.value = ''
      this.secretInputTarget.type = 'password' // Reset to password type if it was toggled
    }

    // Reset the eye icon to default state
    if (this.hasEyeIconTarget) {
      this.eyeIconTarget.classList.remove('fa-eye-slash')
      this.eyeIconTarget.classList.add('fa-eye')
    }
  }

  toggleVisibility(event) {
    event.preventDefault()

    if (!this.hasSecretInputTarget) return

    const input = this.secretInputTarget
    const icon = this.eyeIconTarget

    if (input.type === 'password') {
      input.type = 'text'
      icon.classList.remove('fa-eye')
      icon.classList.add('fa-eye-slash')
    } else {
      input.type = 'password'
      icon.classList.remove('fa-eye-slash')
      icon.classList.add('fa-eye')
    }
  }
}
